var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "label-area", style: _vm.labelAreaStyle }, [
    _c("div", { staticClass: "label", style: _vm.labelStyle }, [
      _vm.required
        ? _c("span", { staticStyle: { color: "red", "margin-right": "4px" } }, [
            _vm._v("*"),
          ])
        : _vm._e(),
      _vm._v(_vm._s(_vm.name) + " "),
    ]),
    _c(
      "div",
      {
        ref: "labelContent",
        staticClass: "label-content ",
        class: { error: _vm.errorClass },
      },
      [
        _vm._t("default"),
        _vm.needValid && _vm.errorMsg
          ? _c(
              "div",
              {
                staticStyle: {
                  position: "absolute",
                  color: "red",
                  "font-size": "14px",
                  left: "0",
                  bottom: "-18px",
                },
              },
              [_vm._v(" " + _vm._s(_vm.errorMsg) + " ")]
            )
          : _vm._e(),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }